import {
  ClientStatusCodes,
  ErrorTypes,
  NetworkStatusCodes,
} from "@/lib/utils/error-definitions";
import { StateCreator } from "zustand";

export interface ISystemError {
  type: ErrorTypes;
  message: string;
  networkStatusCode?: NetworkStatusCodes;
  clientStatusCode?: ClientStatusCodes;
}

export interface IErrorSliceTypes {
  errors: ISystemError[] | null;
  setError: (error: ISystemError) => void;
  removeError: (index: number) => void;
  clearAllErrors: () => void;
}

const initialState = null;

export const ErrorSlice: StateCreator<IErrorSliceTypes> = (set, get) => ({
  errors: initialState,
  setError(error) {
    // Check if the list has errors or is null
    const errorList = get().errors || [];
    const newErrorList = [...errorList, error];
    set(() => ({ errors: newErrorList }));
  },
  removeError(index) {
    const currentErrors = get().errors || [];
    if (index >= 0 && index < currentErrors.length) {
      const newErrors = [
        ...currentErrors.slice(0, index),
        ...currentErrors.slice(index + 1),
      ];
      set(() => ({ errors: newErrors }));
    }
  },
  clearAllErrors() {
    set(() => ({
      errors: initialState,
    }));
  },
});
